<template>
  <div class="booking-summary">
    <div class="booking-summary__box">


      <div class="booking-summary__details-mobile">
        <h3 class="booking-summary__details-mobile__header">{{ listing.post_title }}</h3>
        <div class="booking-summary__details-mobile__date-container">
          <p class="booking-summary__details-mobile__text">{{ checkInDate }} - {{checkOutDate}}</p>
          <button
              @click="toggleMore"
              class="booking-summary__details-mobile__total-container"
              v-if="isCheckout()"
              :class="showMore() ? 'booking-summary__details-mobile__total-container--open' : false"
          >
            <p class="booking-summary__details-mobile__text">{{total}}</p>
            <InlineSvg src="images/icons/UI_Button_Dropdown-Arrow-Navy.svg"></InlineSvg>
          </button>
        </div>
        <DetailedTotals
            :class="showMore() ? 'open' : false"
            :show_more="showMore()"
            descriptor="inline"
        />
      </div>


      <div class="listing-image">
        <div class="listing-image__scrim"></div>
        <img :src="listingImage(listing)" />
        <div
          class="breadcrumb"
          v-if="isConfirmation()">
          <a href="/">Home</a>
          <span>/</span>
          <span>Confirmation</span>
        </div>
        <h1 v-html="title"></h1>
      </div>
      <div class="booking-summary__details">
        <h5 v-html="summaryTitle()"></h5>
        <h3>{{ listing.post_title }}</h3>
        <div class="summary-attributes">
          <div class="attribute-container">
            <InlineSvg src="images/icons/icon-profile.svg"></InlineSvg>
            <div class="attribute-value">{{ listing.sleeps }}</div>
          </div>
          <div class="attribute-container">
            <InlineSvg src="images/icons/icon-bed.svg"></InlineSvg>
            <div class="attribute-value">{{ listing.bedrooms }}</div>
          </div>
          <div class="attribute-container">
            <InlineSvg src="images/icons/icon-shower.svg"></InlineSvg>
            <div class="attribute-value">{{ listing.bathrooms }}</div>
          </div>
        </div>
        <div class="dates">
          <div class="dates__date" v-if="showBookingId()">
            <div class="dates__title">Reservation #</div>
            <div class="dates__value">{{ reservation().confirmation_id }}</div>
          </div>
          <div class="dates__date">
            <div class="dates__title">Check In</div>
            <div class="dates__value">{{ checkInDate }}</div>
          </div>
          <div class="dates__date">
            <div class="dates__title">Check Out</div>
            <div class="dates__value">{{ checkOutDate }}</div>
          </div>
        </div>
        <DetailedTotals :show_more="showMore()" descriptor="inline" />
        <button @click="toggleMore" class="btn btn--dark-blue" v-if="isCheckout()">
          {{ state.show_more_text }}
        </button>
        <div class="create-account-section" v-if="isConfirmation()">
          <p
            v-if="showCreateAccount()"
            v-html="this.$store.state.app_data.create_account_text"
          ></p>
          <button
            class="btn btn--dark-blue"
            @click="openCreateAccountModal"
            v-if="showCreateAccount()"
          >
            Create Account
          </button>
          <a
            href="/account"
            class="btn btn--dark-blue"
            v-if="!showCreateAccount()"
          >
            View Account
          </a>
          <div class="confirmation-links">
            <div class="confirmation-links__group">
              <a
                :href="mailLink()"
                class="confirmation-links__link"
              >
                <i>
                  <InlineSvg src="images/icons/icon-email.svg"></InlineSvg>
                </i>
                <span>Share Trip Details</span>
              </a>
              <button class="confirmation-links__link" @click="print">
                <i>
                  <InlineSvg src="images/icons/icon-print.svg"></InlineSvg>
                </i>
                <span>Print Trip Details</span>
              </button>
            </div>
            <div class="confirmation-links__group">
              <a href="#" class="confirmation-links__link" @click.prevent="openChat">
                <i>
                  <InlineSvg src="images/icons/chat.svg"></InlineSvg>
                </i>
                <span>Need Help?</span>
              </a>
              <a :href="`tel:${phoneHref()}`" class="confirmation-links__link">
                <i>
                  <InlineSvg src="images/icons/phone.svg"></InlineSvg>
                </i>
                <span v-html="$store.state.app_data.customer_service_phone"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DetailedTotals :show_more="showMore()" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InlineSvg from 'vue-inline-svg';
// import ProfileIcon from 'icons/icon-profile.svg?inline';
// import BedIcon from 'icons/icon-bed.svg?inline';
// import ShowerIcon from 'icons/icon-shower.svg?inline';
// import PrintIcon from 'icons/icon-print.svg?inline';
// import PhoneIcon from 'icons/phone.svg?inline';
// import ChatIcon from 'icons/chat.svg?inline';
// import EmailIcon from 'icons/icon-email.svg?inline';
import DetailedTotals from './DetailedTotals.vue';
import axios from 'axios';

export default {
  props: [
    'title',
    'step'
  ],
  data() {
    return {
      state: {
        show_more: false,
        show_more_text: 'Show More'
      }
    }
  },
  components: {
    // ProfileIcon,
    // BedIcon,
    // ShowerIcon,
    // PrintIcon,
    // PhoneIcon,
    // EmailIcon,
    // ChatIcon,
    InlineSvg,
    DetailedTotals
  },
  methods: {
    listingImage(listing) {
      return listing.main_image_url.replace('temp-30d/sandbox/', '')
    },
    phoneHref() {
      return this.$store.state.app_data.customer_service_phone.replace(/\(|\)|\-|\.|\s/g, '')
    },
    showCreateAccount() {
      return (
        this.isConfirmation() &&
        this.$store.state.app_data.current_user === null
      )
    },
    showBookingId() {
      return this.reservation()
    },
    reservation() {
      let reservation
      if (this.$store.state.app_data.reservation) {
        reservation = this.$store.state.app_data.reservation
      } else if (this.$store.state.reservation) {
        reservation = this.$store.state.reservation
      }
      return reservation
    },
    summaryTitle() {
      return this.isConfirmation() ? 'Reservation Confirmed' : 'Your Stay'
    },
    openCreateAccountModal() {
      let request = {}
      request.user = { email: this.$store.state.form.email }
      request.authenticity_token = document.querySelector('[name="csrf-token"]').content
      axios
        .post('/identifications', request)
        .then(({ data: response }) => {
          let html = document.createRange().createContextualFragment(response.html)
          html = html.querySelector('.CreateAccountModal__section') ||
                 html.querySelector('.js-PendingConfirmation__modal') ||
                 html.querySelector('.SignIn__modal')
          document.body.insertAdjacentElement('afterbegin', html)
        })
    },
    toggleMore() {
      this.state.show_more = !this.state.show_more
      this.state.show_more_text = this.state.show_more ? 'Show Less' : 'Show More'
    },
    isConfirmation() {
      return this.step == 'confirmation'
    },
    isCheckout() {
      return this.step == 'checkout'
    },
    showMore() {
      return this.isConfirmation() || this.state.show_more
    },
    openChat() {
      olark('api.box.expand')
    },
    print() {
      window.print()
    },
    mailLink() {
      let { dates, listing } = this.$store.state
      let subject = "You're Going to Florida".replace(/\ /g, '%20')
      let body = [
        listing.website_property_name,
        listing.url,
        `Check In:  ${dates.check_in}`,
        `Check Out: ${dates.check_out}`
      ].join('%0D%0A')

      return `mailto:?subject=${subject}&body=${body}`
    }
  },
  computed: {
    ...mapGetters([
      'checkInDate',
      'checkOutDate',
      'listing',
      'total'
    ])
  }
};
</script>

<style>
@mixin breakpoint $desktop {
  .checkout-layout {
    main {
      padding-top: 8px;
    }

    .header nav.secondary,
    .header nav {
      display: none;
    }

    .header {
      width: calc(100% - 406px);
      border-right: 0;
    }
    .cookie-bar {
      width: calc(100% - 406px);
    }
  }
}
.booking-summary {
  background: $bgGray;
  z-index: 2;
  padding-top: 78px;

  &__details {
    display: none;
    padding: 12px 28px;
  }

  h1 {
    position: absolute;
    bottom: 15px;
    left: 28px;
    font-size: 56px;
    font-weight: 300;
    color: $white;
  }

  h5 {
    font-size: 16px;
    line-height: 1.38;
    letter-spacing: 0.25px;
    color: $gray;
    margin: 0 0 5px 0;
  }

  h3 {
    margin: 0 0 10px 0;
  }

  .btn {
    font-size: 20px;
    line-height: 1.3;
    letter-spacing: 0.14px;
    text-align: center;
    color: $white;
    background: $blueWhale;
    width: 100%;
    margin: 20px 0 0 0;
    white-space: nowrap;
  }

  .listing-image {
    position: relative;
    display: flex;
    align-items: flex-start;
    &__scrim {
      position: absolute;
      opacity: 0.4;
      background: $black;
      width: 100%;
      height: 100%;
    }
  }

  .summary-attributes,
  .attribute-container {
    display: flex;
  }

  .summary-attributes {
    margin: 5px 0;
  }

  .attribute-container {
    height: 22px;
    margin: 0 20px 0 0;
    line-height: 22px;
    width: 40px;
  }

  .attribute-value {
    font-size: 16px;
    color: $gray;
    margin: 0 0 0 7px;
  }

  .dates {
    display: flex;
    flex-flow: column wrap;
    &__date {
      font-size: 16px;
      line-height: 1.63;
      letter-spacing: 0.11px;
      display: flex;
      justify-content: space-between;

      &:last-child {
        border-bottom: 0;
      }
    }

    &__title {
      color: $gray;
    }

    &__value {
      color: $blueWhale;
    }
  }

  .detailed-totals {
    display: none;
    &.inline {
      display: block;

      &.expanded {

      }
    }
  }

  .breadcrumb {
    display: none;
  }

  .create-account-section {
    padding: 30px 0 10px;
    p {
      text-align: center;
    }
  }

  .confirmation-links {
    text-align: center;
    &__link {
      width: 100%;
      padding: 20px 0;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $blueWhale;
      i {
        margin: 0 10px;
      }
      svg {
        width: 27px;
        path {
          fill: $blueWhale;
        }
      }
    }
  }

  &__details-mobile {
    padding: 20px 28px;
    position: fixed;
    top: 58px;
    background-color: $bgGray;
    width: 100%;
    z-index: 2;
    left: 0;
    &__header {
      font-size: 16px;
    }
    &__date-container {
      display: flex;
      justify-content: space-between;
    }
    &__text {
      font-size: 14px;
      color: $blueWhale;
      margin-right: 10px;
    }
    &__total-container {
      display: flex;
      align-items: center;
      &--open {
        svg {
          transform: rotate( 180deg);
        }
      }
    }

    .detailed-totals {
      &.open {
        margin-top: 40px;
      }
      &.inline {
        &.expanded {
          border-top: unset;
        }
      }
    }

    .dates__title,
    .dates__value {
      font-size: 14px;
    }
    .dates__date {
      border-bottom: unset;
      padding: 0;
    }
    .total-price {
      border-top: 2px solid $accent;
      margin-top: 10px;
      padding-top: 10px;
      font-weight: 300;
      font-size: 16px;
    }

  }

  @mixin breakpoint $tablet {
    position: sticky;
    top: 88px;
    padding-top: unset;

    &__box {
      display: flex;
      flex-flow: row-reverse;
    }

    &__details {
      display: block;
      width: 50%;
      flex-shrink: 0;
    }

    &__details-mobile {
      display: none;
    }

    .listing-image {
      h1 {
        display: none;
      }

      img {
        aspect-ratio: 16 / 9;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .detailed-totals {
      display: block;

      &.inline {
        display: none;
      }

      &.expanded {
        padding: 30px 0;
      }

      .dates {
        &__date {
          margin: 0 50px;
        }
      }
    }
  }

  @mixin breakpoint $desktop {
    top: 8px;
    flex-basis: 25%;
    min-width: 390px;
    height: calc(100vh - 16px);
    overflow-y: auto;
    z-index: 99;

    &__details {
      width: 100%;
    }

    &__box {
      flex-flow: column;
    }
    .detailed-totals {
      display: none;

      &.inline {
        display: block;
      }

      &.expanded {
        padding: 0;
      }

      .dates {
        &__date {
          margin: 0;
        }
      }
    }

    .confirmation-links {
      &__group {
        display: flex;
        padding: 0 60px;
        width: 45%;
      }

      &__link {
        padding: 0 16px;
      }
    }
  }
}

#template-confirmation-view {
  .booking-summary {
    @mixin breakpoint $tablet {
      &__details {
        width: 100%;
      }
      &__box {
        flex-flow: column;
      }

      .detailed-totals {
        display: none;
        &.inline {
          display: block;
        }

        &.expanded {
          padding: 0;
        }

        .dates__date {
          margin: 0;
        }
      }
    }

    @mixin breakpoint $desktop {
      height: calc(100vh - 160px);

      &__details {
        width: 25%;
        height: 100%;
        overflow-y: scroll;
      }

      &__box {
        flex-flow: row;
        height: 100%;
      }

      .listing-image {
        width: 75%;
        h1 {
          display: block;
          bottom: initial;
          top: 60px;
          left: 60px;
        }
      }

      .breadcrumb {
        display: block;
        position: absolute;
        top: 30px;
        left: 60px;
        &, a {
          color: white;
        }
      }

      .confirmation-links {
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        height: 80px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}

@media print {
  .checkout-layout {
    background-color: $white;
    border: none;

    &:before,
    &:after {
      display: none;
    }

    .header {
      margin-top: 30px;
      border: none;

      &__bar > * {
        display: none;
      }

      .logo-container {
        display: block;

        svg {
          width: 175px;
          height: auto;
        }
      }
    }

    .cookie-bar {
      display: none;
    }

    main {
      padding-top: 158px;

      &:before,
      &:after {
        display: none;
      }
    }
  }

  #template-confirmation-view {
    .booking-summary {
      background-color: $white;

      .listing-image {
        &__scrim {
          display: none;
        }

        img {
          display: none;
        }

        h1 {
          position: relative;
          left: auto;
          margin: 0 auto;
          color: $blueWhale;
        }
      }

      &__details {
        text-align: center;
      }

      .summary-attributes {
        justify-content: center;
      }

      .create-account-section {
        display: none;
      }
    }
  }
}
</style>
